<template>
<div v-if="preloadDone">
  <div class="text-right mb-2">
    <b-btn size="sm" variant="secondary" v-on:click="clearFilters()">Limpar filtros</b-btn>
  </div>
  <kendo-datasource ref="datasource1" :transport="gridTransport" :schema-model-fields="schemaModelFields" :schema-total="schemaTotal" :schema-data="'data'" :page-size='10' :server-paging="true" :server-filtering="true" :server-sorting="true" :schema-aggregates="schemaAggregates" :server-aggregates="serverAggregates" :aggregate="aggregate" :page="options.dataSource.page"
    :filter="options.dataSource.filter" :sort="options.dataSource.sort">
  </kendo-datasource>
  <kendo-grid ref="mygrid" :height="height" :data-source-ref="'datasource1'" :pageable='pageable' :filterable='filterable' :sortable='sortable' :columns="columns" :scrollable="true">
  </kendo-grid>
</div>
</template>

<script>
import Vue from 'vue'
import kendo from '@progress/kendo-ui/js/kendo.all.js' // eslint-disable-line no-unused-vars
import {
  KendoGrid,
  KendoGridInstaller
} from '@progress/kendo-grid-vue-wrapper'
import {
  KendoDataSource,
  KendoDataSourceInstaller
} from '@progress/kendo-datasource-vue-wrapper'
// var jQuery = require('jquery')

Vue.use(KendoDataSourceInstaller)
Vue.use(KendoGridInstaller)

export default {
  props: ['name', 'schemaModelFields', 'url', 'columns', 'preload', 'sortable', 'pageable', 'filterable', 'height', 'serverAggregates', 'aggregate'],
  components: {
    KendoGrid,
    KendoDataSource
  },
  data() {
    return {
      preloadDone: false,
      gridTransport: this.getTransport(),
      schemaTotal: this.getTotal,
      schemaAggregates: this.getAggregates,
      options: {
        dataSource: {
          page: 1,
          sort: null,
          filter: null
        }
      }
    }
  },
  methods: {
    removeFilter: function(filterField) {
      var gridData = this.$refs.mygrid.kendoWidget()
      var currFilterObj = gridData.dataSource.filter()

      // get current set of filters, which is supposed to be array.
      // if the oject we obtained above is null/undefined, set this to an empty array
      var currentFilters = currFilterObj ? currFilterObj.filters : []

      // iterate over current filters array. if a filter for "filterField" is already
      // defined, remove it from the array
      // once an entry is removed, we stop looking at the rest of the array.
      if (currentFilters && currentFilters.length > 0) {
        for (var i = 0; i < currentFilters.length; i++) {
          if (currentFilters[i].field === filterField) {
            currentFilters.splice(i, 1)
            break
          }
        }
      }
      gridData.dataSource.filter({
        logic: 'and',
        filters: currentFilters
      })
    },
    applyFilter: function(filterField, filterValue, filterType) {
      var filterType = filterType || 'eq'
      var gridData = this.$refs.mygrid.kendoWidget()
      // get currently applied filters from the Grid.
      var currFilterObj = gridData.dataSource.filter()
      console.log(currFilterObj)
      // get current set of filters, which is supposed to be array.
      // if the oject we obtained above is null/undefined, set this to an empty array
      var currentFilters = currFilterObj ? currFilterObj.filters : []

      // iterate over current filters array. if a filter for "filterField" is already
      // defined, remove it from the array
      // once an entry is removed, we stop looking at the rest of the array.
      if (currentFilters && currentFilters.length > 0) {
        for (var i = 0; i < currentFilters.length; i++) {
          if (currentFilters[i].field === filterField) {
            currentFilters.splice(i, 1)
            break
          }
        }
      }
      // if "filterValue" is "0", meaning "-- select --" option is selected, we don't
      // do any further processing. That will be equivalent of removing the filter.
      // if a filterValue is selected, we add a new object to the currentFilters array.
      currentFilters.push({
        field: filterField,
        operator: filterType,
        value: filterValue
      })
      // finally, the currentFilters array is applied back to the Grid, using "and" logic.
      gridData.dataSource.filter({
        logic: 'and',
        filters: currentFilters
      })
    },
    clearFilters: function() {
      var grid = this.$refs.mygrid.kendoWidget()
      grid.dataSource.filter({})
    },
    reload() {
      var grid = this.$refs.mygrid.kendoWidget()
      grid.dataSource.read()
    },
    getTransport() {
      var v = this
      return {
        read: {
          url: v.axios.defaults.baseURL + this.url,
          beforeSend(req) {
            req.setRequestHeader('Authorization', 'Bearer ' + v.$auth.token())
          }
        }
      }
    },
    getTotal(response) {
      return response.meta.pagination.total
    },
    getAggregates(response) {
      return response.meta.aggregates
    },
    setColumnsData(data, field) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].field === field) {
          this.columns[i].values = data
        }
      }
    },
    getGridWidget() {
      try {
        var grid = this.$refs.mygrid.kendoWidget()
        return grid
      } catch (error) {
        return null
      }
    }
  },
  created() {
    var that = this
    if (localStorage[this.name + 'options']) {
      this.options = JSON.parse(localStorage[this.name + 'options'])
    }
    var apiPreloads = []
    if (typeof this.preload !== 'undefined' && this.preload != null && this.preload.length > 0) {
      for (var i = 0; i < this.preload.length; i++) {
        apiPreloads.push(this.preload[i].api)
      }
      this.axios.all(apiPreloads.map(l => this.axios.get(l))).then(
        that.axios.spread(function() {
          for (var i = 0; i < that.preload.length; i++) {
            that.setColumnsData(arguments[i].data.data, that.preload[i].field)
          }
          that.preloadDone = true
        })
      ).catch(response => {
        console.error('error loading foreigns', response)
      })
    } else {
      that.preloadDone = true
    }
  },
  beforeDestroy() {
    try {
      var grid = this.$refs.mygrid.kendoWidget()
      localStorage[this.name + 'options'] = kendo.stringify(grid.getOptions())
    } catch (error) {}
  }
}
</script>
